<span *ngIf="activeUserId === data.value.activeUserId" class="fw-bold" data-test-id="activity-uploaded-you">{{
  'ACTIVITY_YOU' | translate
}}</span>
<app-activities-navigate-profile
  *ngIf="activeUserId !== data.value.activeUserId"
  [user]="data.value.user"
  [dataTestId]="'activity-uploaded-navigate-to-profile'"
  (submit)="onSubmit()"
></app-activities-navigate-profile
>&nbsp;{{ 'ACTIVITY_UPLOADED_FILE' | translate }}&nbsp;<span *ngIf="isDialog" data-test-id="activity-uploaded-this"
  >{{ 'ACTIVITY_THIS' | translate }}&nbsp;</span
>
<a>{{ 'ACTIVITY_FILE' | translate }}</a
><app-activities-display-popup
  *ngIf="!isDialog"
  [rowIndex]="data.rowIndex"
  [value]="data?.value"
  [entityName]="data.value.entity_name"
  [dataTestId]="'file-'"
  (displayPopup)="onDisplayPopup($event)"
></app-activities-display-popup>
